import { render, staticRenderFns } from "./ArrangeDryIce.vue?vue&type=template&id=6b158d3f&scoped=true"
import script from "./ArrangeDryIce.vue?vue&type=script&lang=js"
export * from "./ArrangeDryIce.vue?vue&type=script&lang=js"
import style0 from "./ArrangeDryIce.vue?vue&type=style&index=0&id=6b158d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b158d3f",
  null
  
)

export default component.exports